"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgendamentoCarga = void 0;
var bson_1 = require("bson");
var AgendamentoCarga = /** @class */ (function () {
    function AgendamentoCarga(_a) {
        var _b = _a._id, _id = _b === void 0 ? new bson_1.ObjectId() : _b, _c = _a.dateAndTime, dateAndTime = _c === void 0 ? '' : _c, _d = _a.repeat, repeat = _d === void 0 ? false : _d, _e = _a.numPvs, numPvs = _e === void 0 ? 6 : _e, _f = _a.numPer, numPer = _f === void 0 ? 0 : _f, _g = _a.anoPer, anoPer = _g === void 0 ? '' : _g, _h = _a.materiais, materiais = _h === void 0 ? [] : _h, _j = _a.vendaPostergada, vendaPostergada = _j === void 0 ? [] : _j;
        this._id = _id;
        this.dateAndTime = dateAndTime;
        this.repeat = repeat;
        this.numPvs = numPvs;
        this.numPer = numPer;
        this.anoPer = anoPer;
        this.materiais = materiais;
        this.vendaPostergada = vendaPostergada;
    }
    return AgendamentoCarga;
}());
exports.AgendamentoCarga = AgendamentoCarga;
//# sourceMappingURL=AgendamentoCarga.js.map